import { createSvgComponent } from "../../icon/createSvgComponent";
import DonationTax from "@core/icon/assets/donation-tax.svg";
export default createSvgComponent(DonationTax);